/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultContactList } from '../../models/api-response-paged-result-contact-list';
import { PagedRequestContactList } from '../../models/paged-request-contact-list';

export interface SearchContactList$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestContactList
}

export function searchContactList(http: HttpClient, rootUrl: string, params: SearchContactList$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultContactList>> {
  const rb = new RequestBuilder(rootUrl, searchContactList.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultContactList>;
    })
  );
}

searchContactList.PATH = '/v1/api/ui/contactList/search';
